export default "__VITE_ASSET__AOsKCkSc__"